import styled from 'styled-components';

export const PopupFieldLabel = styled.label`
	width: 60px;
	margin: 6px 0;
	font-size: 14px;
`;

export const PopupField = styled.div`
	width: 120px;
	margin: 0 0 16px;
	font-size: 14px;
`;